module.exports = __webpack_public_path__ + "static/miraj-664dc7d295e235d015bd24c799515cbb.mp4";